var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer"},[_c('div',{staticClass:"inner"},[_c('nuxt')],1),_vm._v(" "),_c('critical-error-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }